(() => {
  document.querySelectorAll('[data-pt-creators]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rail = root.querySelector('[data-rail]');
    // Opt-in, device-local diagnostics. No reports or device details are transmitted.
    const diagnosticMode = new URLSearchParams(location.search).get('video-debug') === '1';
    let report;
    let lines = [];
    const log = (name, event, video, detail) => {
      if (!report) return;
      lines.push(name + ': ' + event + ' | ready=' + video.readyState + ' network=' + video.networkState + ' time=' + video.currentTime.toFixed(1) + ' error=' + (video.error ? video.error.code + ' ' + video.error.message : 'none') + (detail ? ' | ' + detail : ''));
      report.value = navigator.userAgent + '\n' + lines.slice(-60).join('\n');
    };
    if (diagnosticMode) {
      const panel = document.createElement('section');
      panel.id = 'video-diagnostics';
      panel.className = 'pt-video-diagnostics';
      const heading = document.createElement('h3'); heading.textContent = 'Video playback check'; panel.append(heading);
      const help = document.createElement('p'); help.textContent = 'Try each native player below, then a creator card. Copy the report to share what happened. This report stays on your device.'; panel.append(help);
      report = document.createElement('textarea'); report.readOnly = true; report.rows = 8; report.setAttribute('aria-label', 'Video playback report');
      const first = root.querySelector('[data-video]');
      [['Native MP4', first.dataset.video], ['Native HLS', first.dataset.stream]].forEach(([name, url]) => {
        const title = document.createElement('h4'); title.textContent = name; panel.append(title);
        const native = document.createElement('video'); native.controls = true; native.playsInline = true; native.preload = 'none'; native.src = url; panel.append(native);
        ['loadstart','loadedmetadata','canplay','play','playing','waiting','stalled','pause','error'].forEach(event => native.addEventListener(event, () => log(name,event,native)));
        const link = document.createElement('a'); link.href = url; link.textContent = 'Open ' + name + ' directly'; link.target = '_blank'; link.rel = 'noopener'; panel.append(link);
      });
      panel.append(report);
      const copy = document.createElement('button'); copy.type = 'button'; copy.textContent = 'Copy report'; copy.addEventListener('click', async () => { try { await navigator.clipboard.writeText(report.value); copy.textContent = 'Copied'; } catch (_) { report.focus(); report.select(); } }); panel.append(copy);
      root.querySelector('.pt-creators__inner').prepend(panel);
      report.value = navigator.userAgent + '\nTap play to begin.';
    }
    const updateArrows = () => {
      root.querySelector('[data-direction="-1"]').disabled = rail.scrollLeft <= 2;
      root.querySelector('[data-direction="1"]').disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    rail.addEventListener('scroll', updateArrows, {passive:true});
    new ResizeObserver(updateArrows).observe(rail);
    updateArrows();
    root.querySelectorAll('[data-direction]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('video').forEach(video => video.pause());
        const step = rail.querySelector('li').getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap);
        const index = Math.round(rail.scrollLeft / step) + Number(button.dataset.direction);
        rail.scrollTo({left:index * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) entry.target.querySelector('video').pause(); });
    }, {threshold:0.15}) : null;
    root.querySelectorAll('.pt-creators__card').forEach(card => {
      const trigger = card.querySelector('[data-video]');
      const video = card.querySelector('video');
      const error = card.querySelector('[data-error]');
      let fallbackUsed = false;
      const direct = document.createElement('a'); direct.href = trigger.dataset.video; direct.target = '_blank'; direct.rel = 'noopener'; direct.textContent = 'Open video directly'; error.append(' ', direct);
      ['loadstart','loadedmetadata','canplay','play','playing','waiting','stalled','pause','error'].forEach(event => video.addEventListener(event, () => log(trigger.getAttribute('aria-label'),event,video)));
      video.poster = trigger.querySelector('img').src;
      video.setAttribute('aria-label', trigger.getAttribute('aria-label').replace(/^Play /, ''));
      const play = () => {
        const promise = video.play();
        if (promise) promise.catch(reason => {
          log(trigger.getAttribute('aria-label'),'play rejected',video,reason.name + ': ' + reason.message);
          if (reason.name !== 'AbortError' && reason.name !== 'NotAllowedError') error.hidden = false;
        });
      };
      trigger.addEventListener('click', () => {
        trigger.hidden = true;
        video.hidden = false;
        error.hidden = true;
        if (!video.getAttribute('src')) {
          video.src = trigger.dataset.video;
          if (trigger.dataset.captions) {
            fetch(trigger.dataset.captions, {credentials: 'omit'})
              .then(response => {
                if (!response.ok) throw new Error('Caption HTTP ' + response.status);
                return response.text();
              })
              .then(text => {
                const track = document.createElement('track');
                const url = URL.createObjectURL(new Blob([text], {type: 'text/vtt'}));
                track.kind = 'captions'; track.srclang = 'en'; track.label = 'English'; track.default = true;
                track.src = url;
                track.addEventListener('load', () => {
                  log(trigger.getAttribute('aria-label'), 'captions loaded', video);
                }, {once: true});
                track.addEventListener('error', () => {
                  log(trigger.getAttribute('aria-label'), 'captions unavailable', video);
                  URL.revokeObjectURL(url);
                }, {once: true});
                video.append(track);
              })
              .catch(reason => log(trigger.getAttribute('aria-label'), 'captions unavailable', video, reason.message));
          }
        }
        play();
        video.focus({preventScroll:true});
      });
      video.tabIndex = 0;
      video.addEventListener('play', () => document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }));
      video.addEventListener('playing', () => { error.hidden = true; });
      video.addEventListener('error', () => {
        if (!video.getAttribute('src')) return;
        if (!fallbackUsed && trigger.dataset.stream && video.canPlayType('application/vnd.apple.mpegurl')) {
          fallbackUsed = true;
          video.src = trigger.dataset.stream;
          play();
        } else error.hidden = false;
      });
      card.querySelector('[data-retry]').addEventListener('click', () => {
        error.hidden = true;
        fallbackUsed = false;
        video.src = trigger.dataset.video;
        play();
      });
      observer?.observe(card);
    });
  });
})();
